import Store from 'app/redux/store'
import { bindActions } from 'redux-zero/utils'
import Business from 'app/interface/data/business'
import { BusinessError } from '@marketing-milk/interfaces'
import BusinessDefault from 'app/redux/default/pages/business'

const BusinessActions = bindActions(
  () => ({
    // DRI-116: new businesses start in Facebook Builder mode; Authorizers stays reachable via the
    // panel's switch. Only here, not in BusinessDefault — init() merges over that default for
    // existing businesses, whose fb_builder is derived server-side.
    initEmpty: state => ({
      pages: {
        ...state.pages,
        business: {
          ...BusinessDefault,
          main: { ...BusinessDefault.main, fb_builder: true },
        },
      },
    }),

    init: (state: any, business: Business) => ({
      pages: {
        ...state.pages,
        business: {
          ...BusinessDefault,
          ...business,
        },
      },
    }),

    resetError: (state: any) => ({
      pages: {
        ...state.pages,
        business: {
          ...state.pages.business,
          error: null,
        },
      },
    }),

    // updates just the persisted error flags after a save (e.g. an FB access issue that didn't block
    // the save) — a plain `init()` would clobber unrelated fields since it merges over BusinessDefault
    setErrors: (state: any, errors: BusinessError[] | null) => ({
      pages: {
        ...state.pages,
        business: {
          ...state.pages.business,
          errors: errors ?? [],
        },
      },
    }),
  }),
  Store
)

export default BusinessActions
